import axios from 'axios'
import config from './config'
import router from './router'
import store from './store'
// import router from './router'

const timeout = 60000 // in milisecond

export default function(payload) {
  axios.defaults.baseURL = config.baseApi
  axios.defaults.timeout = timeout
  axios.defaults.headers.common['Authorization'] = 'Bearer '+store.getters.accessToken || ''

  return new Promise ((resolve, reject) => {
    axios(payload)
    .then(result => {
      resolve(result)
    })
    .catch(error => {
      // console.log(error.response.status)
      if (error.response.status == 401) {
        router.push({ name: 'Login' })
        // this.$router.push({ name: 'Login', params: { lang: this.$i18n.locale } })
        // window.location.replace('/id/admin')
      } else {
        reject(error)
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/networkClient.js